import { Loader } from "../common";

// Backwards compatibility wrapper for AuthorPageLoader
export default function AuthorPageLoader({ message = "Loading..." }) {
  return <Loader type="bar" message={message} fullPage={true} />;
}
